import React from "react";
import { Helmet } from "react-helmet";
import Blog from "./Blog";

function index() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Blog</title>
        <meta
          name="description"
          content="Catch our latest blog on variety of topics to be at the top of the latest techologies, services trending all around the globe."
        />
      </Helmet>
      <Blog />
    </>
  );
}

export default index;
